module.exports = __webpack_public_path__ + "img/FDM.428dab9f.png";